import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import {localization} from '../Frames/localization'
import Grid from '@material-ui/core/Grid';

//Маска
import MaskedInput from 'react-text-mask';
//import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import {messageWindow} from '../Elements/Snackbar/MessageWindow'
import MessageWindow from '../Elements/Snackbar/MessageWindow'

import Button from "../Elements/Button/buttons";
import { authenticationService } from './_services';

//AppBar
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
//Icon
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

//style
import {ColorLinearProgress, AppliedSettings} from '../../src/App'
import {useStyles, CssTextField,ThemeTabLogin} from '../../src/App'
import './Login.css'
import './LoginAdaptive.css'

//showPassword
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { ThemeProvider } from '@material-ui/core';

/*Settings
      login_show_main_logo: true,
      login_use_reset_password: true,
      login_input_type_view: undefined, //ENUM
      login_input_border_color: '',
      login_button_background_color: '#3f51b5',
      login_button_text_color: '#ffffff',
      login_use_top_text: true,
      login_use_login_text: true,
      login_use_password_text: true,
*/
const baseUrl = process.env.PUBLIC_URL;

class Login extends Component{
    constructor(props) {
        super(props);
        this.state = {
            login: '',
            password: '',
            showPassword: false,
            phone: '',
            card: '',

            asyncDisabled: false,
            progress: false,

            key: this.props.key,
            isLoaded: false,
            message: '',

            value: 0,
            oneField: false,
        };         
        this.onChangeLogin = this.onChangeLogin.bind(this);
        this.onChangeLoginPhone = this.onChangeLoginPhone.bind(this);
        this.onChangeLoginCard = this.onChangeLoginCard.bind(this);
        this.onChangePhone = this.onChangePhone.bind(this);
        this.onChangeCard = this.onChangeCard.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.resetPass = this.resetPass.bind(this);
        this.handleClick = this.handleClick.bind(this)
        this.handleClose = this.handleClose.bind(this)
      }
      handleChange = (event, newValue) => {
        this.setState({value: newValue, login: '', card: '', phone: ''});
      };
      componentDidMount()
      {
        this.props.setSelectedIndex(-1)
        this.setState({login: localStorage.getItem('login', this.state.login),
        card: localStorage.getItem('card', this.state.card),
        phone: localStorage.getItem('phone', this.state.phone),
        value: this.getDefaultValue()})
      }
      getDefaultValue()
      {
        var ArrayAllowTab = [0, 1, 2];
        if(AppliedSettings.loginPhoneNum == false)
        {
          ArrayAllowTab[0] = null
        }
        if(AppliedSettings.loginCardCode == false)
        {
          ArrayAllowTab[1] = null
        }
        if(AppliedSettings.loginEmail == false)
        {
          ArrayAllowTab[2] = null
        }

        if(ArrayAllowTab.indexOf(Number(localStorage.getItem('SelectTabs'))) != -1)
        {
          return Number(localStorage.getItem('SelectTabs'))
        }else
        {
          if(AppliedSettings.loginPhoneNum == true)
          {
            return 0;
          }
          if(AppliedSettings.loginCardCode == true)
          {
            return 1;
          }
          if(AppliedSettings.loginEmail == true)
          {
            return 2;
          }
        }         
      }
      handleClick = () => {
        this.setState({open: true})
      };
      handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        this.setState({open: false})
      };
      resetPass()
      {
        this.setState({asyncDisabled: true, progress: true})
        localStorage.setItem('login', this.state.login);
        localStorage.setItem('card', this.state.card);
        localStorage.setItem('phone', this.state.phone);
        localStorage.setItem('SelectTabs', this.state.value);
        if (this.state.login.length < 1)
        {
          messageWindow.OpenMessage("error",localization.GetTranslate('Login.requiredCard'))
          this.setState({asyncDisabled: false, progress: false, key: Math.random()})
          return;
        }
        const requestOptionsExit = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({use: this.state.login})
      }
      
        fetch(`/api/resetpass`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({asyncDisabled: false, progress: false, key: Math.random()})
            }
            return response.json()})
        .then((response) => {
            if(response.error)
            {
                messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                this.setState({asyncDisabled: false, progress: false, key: Math.random()})
            }else if(response.data)
            {
                messageWindow.OpenMessage("info", localization.GetTranslate(response.data))
                this.setState({asyncDisabled: false, progress: false, key: Math.random()})
            }          
        })
      }
    onSubmit(event){
        event.preventDefault();
        this.setState({asyncDisabled: true, progress: true})
        localStorage.setItem('selectedIndex', 0);
        localStorage.setItem('login', this.state.login);
        localStorage.setItem('card', this.state.card);
        localStorage.setItem('phone', this.state.phone);
        localStorage.setItem('SelectTabs', this.state.value);
        authenticationService.login(this.state.login, this.state.password, event)
        .then(
            user => {
                var { from } = { from: { pathname: baseUrl + "/stats" } };
                if(AppliedSettings.show_statistics_page === true)
                {
                  from  = { pathname: baseUrl + "/stats" } ;
                }else if(AppliedSettings.show_operations_page === true)
                {
                  from = { pathname: baseUrl + "/operations" } ;
                }else if(AppliedSettings.show_clientInfo_page === true)
                {
                  from  = { pathname: baseUrl + "/clientInfo" };
                }
                else if(AppliedSettings.show_security_page === true)
                {
                  from  ={ pathname: baseUrl + "/security" } ;
                }else if(AppliedSettings.show_transferring_funds_page === true)
                {
                  from  =  { pathname: baseUrl + "/transferringFunds" } ;
                }
                else if(AppliedSettings.show_limits_page === true)
                {
                  from  =  { pathname: baseUrl + "/limits" } ;
                }
                else if(AppliedSettings.show_cashback_page === true)
                {
                  from  = { pathname: baseUrl + "/cashback" } ;
                }
                this.props.history.push(from);   
            }
        );
      }
  
      onChangePassword(event){
        this.setState({password: event.target.value});
      }
  
      onChangeLogin(event) {
        this.setState({login: event.target.value});
      }
      onChangeLoginPhone(event) {
        this.setState({login: event.target.value.replace(/[^0-9,^+]/g, '')});
      }
      onChangeLoginCard(event) {
        this.setState({login: event.target.value.replace(/[^0-9]/g, '')});
      }
      onChangePhone(event) {
        this.setState({phone: event.target.value});
      }
      onChangeCard(event) {
        this.setState({card: event.target.value});
      }

      handleClickShowPassword = (event) => {
        this.setState({ showPassword: !this.state.showPassword });
      };
    
      handleMouseDownPassword = event => {
        event.preventDefault();
      };
      typeInput(type)
      {
          switch(type)
          {
              case 0: return;
              case 1: return "filled";
              case 2: return "outlined";
          }
      }
    render(){    
        const {progress} = this.state;
        const {AppliedSettings, theme} = this.props;
        var {oneField,value} = this.state;
        var tr = {
            NumberCard: localization.GetTranslate('Login.Number Card'),
            Password: localization.GetTranslate('Login.Password'),
            Enter: localization.GetTranslate('Login.Enter'),
            Resetpass: localization.GetTranslate('buttons.Resetpass'),
            Card: localization.GetTranslate('Login.Card'),
            Phone: localization.GetTranslate('Login.Phone'),
            Email: localization.GetTranslate('Login.Email'),
        }    
        //Применение маски

        //Панель вкладок
        var Bar = <div>
          <ThemeProvider theme={ThemeTabLogin}>
          <Tabs
            variant="fullWidth"
            value={value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable auto tabs example"
            className="TabsLogin"
            TabIndicatorProps = { {
              style : {
                backgroundColor :  AppliedSettings.Indicator_color_tabs_login
             }
           } }
          >
            {AppliedSettings.loginPhoneNum &&
            <Tab value={0} className="TabLogin" icon={<PhoneEnabledIcon className="icon"/>} label={tr.Phone} {...a11yProps(0)} />
            }
            {AppliedSettings.loginCardCode &&
            <Tab value={1} className="TabLogin" icon={<CreditCardIcon className="icon"/>} label={tr.Card} {...a11yProps(1)} />
            }
            {AppliedSettings.loginEmail &&
            <Tab value={2} className="TabLogin" icon={<MailOutlineIcon className="icon"/>} label={tr.Email} {...a11yProps(2)} />
            }
          </Tabs>
          </ThemeProvider>
        </div>
        if(AppliedSettings.loginCardCode == true & AppliedSettings.loginPhoneNum == false & AppliedSettings.loginEmail == false ||
            AppliedSettings.loginCardCode == false & AppliedSettings.loginPhoneNum == true & AppliedSettings.loginEmail == false ||
            AppliedSettings.loginCardCode == false & AppliedSettings.loginPhoneNum == false & AppliedSettings.loginEmail == true)
        {
            if(AppliedSettings.loginPhoneNum == true)
            {
                value = 0
            }
            if(AppliedSettings.loginCardCode == true)
            {
                value = 1
            }
            if(AppliedSettings.loginEmail == true)
            {
                value = 2
            }
            oneField = true;
            Bar = null;
        }
        return (   
            <div> 
            {progress &&
            <div className="progress">
                <ColorLinearProgress />   
            </div>
            }  
            <MessageWindow key={this.state.key}></MessageWindow>    
        <div style={useStyles.LoginPosition} className="LoginPosition">  
            <div style={useStyles.LoginForm} className="LoginForm">                   
                    <Paper className="LoginBox">
                        <div className="Formblock">
                            {AppliedSettings.login_show_main_logo &&
                              <div>
                                {theme === "light" &&
                                  <img alt="...loading..." className="LoginLogo" src={baseUrl + "/images/loyalty_logo_light.png"}></img>
                                }
                                {theme === "dark" &&
                                  <img alt="...loading..." className="LoginLogo" src={baseUrl + "/images/loyalty_logo_dark.png"}></img>
                                }
                              </div>
                            }
                            <Grid container justify="center" spacing={3}>
                            <form className="Form" onSubmit={this.onSubmit}>
                                <Grid style={{paddingTop: 15}} item xs={"auto"}>
                                  {Bar}
                                </Grid>
                                <Grid style={{paddingTop: 0}} item xs={"auto"}>
                                {/*value == -1 &&
                                    <CssTextField
                                    name="login"
                                    onChange={this.onChangeLogin}
                                    value={this.state.login}
                                    label={tr.NumberCard}
                                    margin="normal"
                                    style={useStyles.LoginField}
                                    className="InputField"
                                    variant={this.typeInput(AppliedSettings.login_input_type_view)}
                                    required={true}/>
                                */}
                                {value == 0 &&
                                    <CssTextField
                                    name="login"
                                    onChange={this.onChangeLoginPhone}
                                    value={this.state.login}
                                    label={oneField == true ? tr.Phone:null}
                                    margin="normal"
                                    style={useStyles.LoginField}
                                    className="InputField"
                                    variant={this.typeInput(AppliedSettings.login_input_type_view)}
                                    required={true}
                                    InputProps={{
                                        placeholder: AppliedSettings.login_phone_mask,
                                        inputComponent: TextMaskCustomPhone
                                    }}
                                    inputProps={{
                                      value: this.state.phone,
                                      onChange: this.onChangePhone
                                    }}/>
                                }
                                {value == 1 &&
                                    <CssTextField
                                    name="login"
                                    onChange={this.onChangeLoginCard}
                                    value={this.state.login}
                                    label={oneField == true ? tr.NumberCard:null}
                                    margin="normal"
                                    style={useStyles.LoginField}
                                    className="InputField"
                                    variant={this.typeInput(AppliedSettings.login_input_type_view)}
                                    required={true}
                                    InputProps={{
                                        placeholder: AppliedSettings.login_card_mask,
                                        inputComponent: TextMaskCustomCard
                                    }}
                                    inputProps={{
                                      value: this.state.card,
                                      onChange: this.onChangeCard
                                    }}/>
                                }
                                {value == 2 &&
                                    <CssTextField
                                    name="login"
                                    type="email"
                                    onChange={this.onChangeLogin}
                                    value={this.state.login}
                                    label={oneField == true ? tr.Email:null}
                                    margin="normal"
                                    style={useStyles.LoginField}
                                    className="InputField"
                                    variant={this.typeInput(AppliedSettings.login_input_type_view)}
                                    required={true}
                                    inputProps={{
                                        placeholder: 'sales@ekka.com.ua'
                                    }}
                                    />
                                }
                                </Grid>
                                <Grid item xs={"auto"}>
                                <CssTextField id="inputPassword"
                                           label={tr.Password}
                                           name="password"
                                           onChange={this.onChangePassword}
                                           value={this.state.password}
                                           type={this.state.showPassword ? 'text' : 'password'}
                                           InputProps={{
                                               endAdornment: (
                                                    <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={this.handleClickShowPassword}
                                                        onMouseDown={this.handleMouseDownPassword}
                                                    >
                                                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                    </InputAdornment>
                                               )
                                            }}
                                           autoComplete="current-password"
                                           margin="normal"
                                           variant={this.typeInput(AppliedSettings.login_input_type_view)}
                                           style={useStyles.LoginField}
                                           className="InputField"
                                           required={true}/>    
                                </Grid>
                                <Grid style={{padding: 0}} item xs={"auto"}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    type="submit"
                                    value="submit"
                                    textLabel={tr.Enter}
                                    className="LoginButton"
                                    disabled={this.state.asyncDisabled}
                                    style={{background: AppliedSettings.login_button_background_color}}
                                >
                                </Button>  
                                </Grid>
                                                        
                            </form>
                            {AppliedSettings.login_use_reset_password &&
                                <Grid style={{paddingTop: 0}} item xs={"auto"}>
                                <Button
                                    color="primary"
                                    onClick = {this.resetPass}
                                    variant="contained"
                                    textLabel={tr.Resetpass}
                                    className="LoginButton"
                                    disabled={this.state.asyncDisabled}
                                    style={{background: AppliedSettings.login_button_background_color}}
                                >
                                </Button>
                                </Grid>
                            }
                            </Grid> 
                        </div>
                    </Paper> 
                </div>
                </div>
                </div> 
        );
    }
}

/*const defaultMaskOptions = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ' - ',
  allowDecimal: true,
  decimalSymbol: '.',
  integerLimit: 16, // limit length of integer numbers
  allowNegative: false,
  allowLeadingZeroes: false,
}*/
function DecoderMaskInArray(maskString)
{
  var mask = maskString.split('');
  for(var i = 0; i < mask.length; i++)
  {
    if(mask[i] === 'x' | mask[i] === 'х' | mask[i] === 'х'){
      mask[i] = /\d/
    }
  }  
  return mask;
}
function TextMaskCustomPhone(props) {
    const { inputRef, ...other } = props;
    return (
      <MaskedInput
      guide={false}
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={DecoderMaskInArray(AppliedSettings.login_phone_mask)}
        //mask={['+', '3', '8','(', '0', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', '-', ' ', /\d/, /\d/,' ', '-', ' ', /\d/, /\d/]}
        showMask
      />
    );
  }
  function TextMaskCustomCard(props) {
    const { inputRef, ...other } = props;
    /*const currencyMask = createNumberMask({
      ...defaultMaskOptions,
    })*/
    return (
      <MaskedInput
        {...other}
        guide={false}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={DecoderMaskInArray(AppliedSettings.login_card_mask)}
        //mask={currencyMask}
        //mask={[/\d/, /\d/, /\d/, /\d/,' ', '-', ' ', /\d/, /\d/, /\d/, /\d/,' ', '-', ' ',/\d/, /\d/, /\d/, /\d/,' ', '-', ' ',/\d/, /\d/, /\d/, /\d/]}
        showMask={false}
      />
    );
  }
  TextMaskCustomPhone.propTypes = {
    inputRef: PropTypes.func.isRequired
  };
  TextMaskCustomCard.propTypes = {
    inputRef: PropTypes.func.isRequired
  };




function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }
export default Login;